module.exports = __webpack_public_path__ + "static/fonts/fontello.6700063.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/fontello/font/fontello.eot?32974303
// module id = /oAE
// module chunks = 20